import React from "react";

const STATE_COLORS = {
  idle: ["#6366F1", "#4F46E5", "#7C3AED"],
  thinking: ["#818CF8", "#4F46E5", "#6366F1"],
  working: ["#7C3AED", "#4F46E5", "#6366F1"],
  success: ["#10B981", "#059669", "#34D399"],
  approval: ["#F59E0B", "#D97706", "#FBBF24"],
  alert: ["#EF4444", "#DC2626", "#F87171"],
};

// Pure-CSS approximation of the mobile reanimated AI Orb.
export function Orb({ state = "idle", size = 120 }) {
  const c = STATE_COLORS[state] || STATE_COLORS.idle;
  const fast = state === "thinking" || state === "working";
  const core = size * 0.72;
  return (
    <div
      role="img"
      aria-label={`EARNOS orb, ${state}`}
      style={{ width: size, height: size, position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div
        className={fast ? "animate-orb-glow-fast" : "animate-orb-glow-slow"}
        style={{
          position: "absolute",
          width: size,
          height: size,
          borderRadius: "50%",
          background: c[0],
          filter: "blur(18px)",
          opacity: 0.35,
        }}
      />
      <div
        className={fast ? "animate-orb-pulse-fast" : "animate-orb-pulse-slow"}
        style={{
          width: core,
          height: core,
          borderRadius: "50%",
          background: `linear-gradient(135deg, ${c[0]}, ${c[1]} 55%, ${c[2]})`,
          boxShadow: `0 8px 40px ${c[1]}88`,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            background: "radial-gradient(circle at 32% 22%, rgba(255,255,255,0.55), rgba(255,255,255,0) 55%)",
          }}
        />
      </div>
    </div>
  );
}
